'use strict';

import { Entity } from '../Entity';
import { App } from '../App';
import { User } from './User';

export class UserPersonalToken extends Entity {
  protected id;
  protected app;
  protected user;
  protected name;
  protected accessToken;
  protected username;
  protected password;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.accessToken = data.accessToken;
    this.username = data.username;
    this.password = data.password;

    if (data.app) {
      const app = new App();

      app.hydrate(data.app);

      this.app = app;
    }

    if (data.user) {
      const user = new User();

      user.hydrate(data.user);

      this.user = user;
    }
  }

  public getName() {
    return this.name;
  }

  public getAccessToken() {
    return this.accessToken;
  }

  public getApp() {
    return this.app;
  }

  public getId() {
    return this.id;
  }

  public getUsername() {
    return this.username;
  }

  public getPassword() {
    return this.password;
  }
}
